// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"_2oaSQURoRkjBl2kDoIPSJ","success":"_2F1KPQnAHwA-SnsDdIYQds","error":"_1NqVpuaHiPNWvvOTQCQRtn"};